<div class="container-fluid p-4">
    <!-- Header -->
    <div class="flex items-start justify-between mb-4">
        <div>
            <h2 class="text-2xl font-bold text-gray-800">Categorías de Desactivación</h2>
            <p class="text-sm text-gray-500 mt-1">
                Agrupa los motivos de desactivación de cupo y asocia el mensaje friendly que verá el cliente en la app.
            </p>
        </div>
        <button (click)="openCreate()"
                class="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded shadow">
            <i class="fas fa-plus mr-1"></i> Nueva categoría
        </button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="text-gray-500 text-sm py-8 text-center">
        <i class="fas fa-spinner fa-spin"></i> Cargando…
    </div>

    <!-- Empty -->
    <div *ngIf="!loading && categories.length === 0"
         class="bg-white border border-gray-200 rounded-lg p-8 text-center">
        <i class="fas fa-folder-open text-gray-300 text-4xl mb-3"></i>
        <p class="text-gray-600">Aún no hay categorías creadas.</p>
        <button (click)="openCreate()" class="mt-3 text-blue-600 hover:underline text-sm">
            Crear la primera
        </button>
    </div>

    <!-- Lista -->
    <div *ngIf="!loading && categories.length > 0" class="space-y-3">
        <div *ngFor="let c of categories"
             class="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
            <div class="flex items-start justify-between gap-4">
                <div class="flex-1 min-w-0">
                    <div class="flex items-center gap-2">
                        <span class="text-xs font-mono uppercase bg-gray-100 text-gray-700 px-2 py-0.5 rounded">{{ c.code }}</span>
                        <h3 class="font-semibold text-gray-900">{{ c.name }}</h3>
                        <span *ngIf="!c.status"
                              class="text-xs px-2 py-0.5 rounded bg-gray-200 text-gray-600">Inactiva</span>
                    </div>
                    <p class="text-sm text-gray-700 mt-2 italic">"{{ c.message_for_client }}"</p>

                    <div class="mt-3 flex flex-wrap items-center gap-2 text-xs">
                        <span class="text-gray-500">Motivos manuales:</span>
                        <ng-container *ngIf="(c.option_indexes || []).length > 0; else noOpts">
                            <span *ngFor="let i of c.option_indexes"
                                  class="bg-blue-50 text-blue-700 border border-blue-200 px-2 py-0.5 rounded">
                                {{ i }}. {{ reasonLabelFor(i) }}
                            </span>
                        </ng-container>
                        <ng-template #noOpts>
                            <span class="text-gray-400">(ninguno)</span>
                        </ng-template>
                    </div>

                </div>

                <div class="flex flex-col gap-1">
                    <button (click)="openEdit(c)"
                            class="text-blue-600 hover:bg-blue-50 text-xs px-3 py-1 rounded">
                        <i class="fas fa-pen"></i> Editar
                    </button>
                    <button (click)="remove(c)"
                            class="text-red-600 hover:bg-red-50 text-xs px-3 py-1 rounded">
                        <i class="fas fa-trash"></i> Eliminar
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal crear/editar -->
    <div *ngIf="showModal"
         class="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center p-4">
        <div class="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div class="px-5 py-3 border-b flex items-center justify-between">
                <h3 class="font-bold text-lg text-gray-800">
                    {{ isEditing ? 'Editar categoría' : 'Nueva categoría' }}
                </h3>
                <button (click)="closeModal()" class="text-gray-400 hover:text-gray-600">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="p-5 space-y-4">
                <!-- code -->
                <div>
                    <label class="text-xs uppercase tracking-wide font-semibold text-gray-600">
                        Código (identificador interno)
                    </label>
                    <input type="text"
                           [(ngModel)]="form.code"
                           [disabled]="isEditing"
                           class="w-full mt-1 border rounded px-3 py-2 text-sm uppercase"
                           placeholder="FINANCIAL">
                    <p *ngIf="formErrors.code" class="text-xs text-red-600 mt-1">{{ formErrors.code }}</p>
                    <p *ngIf="!isEditing" class="text-xs text-gray-400 mt-1">
                        Solo mayúsculas, números y guion bajo. No se puede cambiar después.
                    </p>
                </div>

                <!-- name -->
                <div>
                    <label class="text-xs uppercase tracking-wide font-semibold text-gray-600">
                        Nombre
                    </label>
                    <input type="text"
                           [(ngModel)]="form.name"
                           class="w-full mt-1 border rounded px-3 py-2 text-sm"
                           placeholder="Financiero">
                    <p *ngIf="formErrors.name" class="text-xs text-red-600 mt-1">{{ formErrors.name }}</p>
                </div>

                <!-- message_for_client -->
                <div>
                    <label class="text-xs uppercase tracking-wide font-semibold text-gray-600">
                        Mensaje para el cliente
                    </label>
                    <textarea [(ngModel)]="form.message_for_client"
                              rows="3"
                              class="w-full mt-1 border rounded px-3 py-2 text-sm"
                              placeholder="Tu cupo está temporalmente suspendido..."></textarea>
                    <p *ngIf="formErrors.message_for_client" class="text-xs text-red-600 mt-1">{{ formErrors.message_for_client }}</p>
                    <p class="text-xs text-gray-400 mt-1">
                        Este es el texto que verá el cliente en la app cuando su cupo esté inactivo y caiga en esta categoría.
                    </p>
                </div>

                <!-- option_indexes -->
                <div>
                    <label class="text-xs uppercase tracking-wide font-semibold text-gray-600">
                        Motivos manuales asociados
                    </label>
                    <p class="text-xs text-gray-400 mt-1 mb-1">
                        Cada motivo solo puede pertenecer a una categoría. Los que ya están asignados a otra se muestran deshabilitados.
                    </p>
                    <div class="mt-2 grid grid-cols-1 gap-1">
                        <label *ngFor="let r of reasons"
                               class="flex items-start gap-2 text-sm rounded px-2 py-1"
                               [class.cursor-pointer]="!isOptionTaken(r.index)"
                               [class.cursor-not-allowed]="isOptionTaken(r.index)"
                               [class.hover:bg-gray-50]="!isOptionTaken(r.index)"
                               [class.opacity-60]="isOptionTaken(r.index)">
                            <input type="checkbox"
                                   [checked]="isOptionChecked(r.index)"
                                   [disabled]="isOptionTaken(r.index)"
                                   (change)="toggleOption(r.index, $any($event.target).checked)"
                                   class="mt-1">
                            <span class="flex-1">
                                <strong>{{ r.index }}.</strong> {{ r.label }}
                                <span *ngIf="isOptionTaken(r.index)" class="ml-2 text-xs text-amber-700 italic">
                                    (en uso por "{{ takenByCategoryName(r.index) }}")
                                </span>
                            </span>
                        </label>
                    </div>
                </div>

                <!-- status -->
                <div class="flex items-center gap-2">
                    <label class="flex items-center gap-2 cursor-pointer">
                        <input type="checkbox" [(ngModel)]="form.status">
                        <span class="text-sm text-gray-700">Activa</span>
                    </label>
                </div>
            </div>

            <div class="px-5 py-3 border-t flex items-center justify-end gap-2 bg-gray-50">
                <button (click)="closeModal()" class="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded">
                    Cancelar
                </button>
                <button (click)="save()"
                        [disabled]="submitting"
                        class="px-4 py-2 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded shadow disabled:opacity-50">
                    <i *ngIf="submitting" class="fas fa-spinner fa-spin mr-1"></i>
                    {{ isEditing ? 'Guardar cambios' : 'Crear' }}
                </button>
            </div>
        </div>
    </div>
</div>
